import { get, isEmpty, map, size, keys, includes } from 'lodash-es';

/**
 * Get code first error
 * @param {array} questions
 * @param {object} errors
 * @returns {*}
 */
const getCodeFirstError = ({ questions, errors }) => {
  try {
    if (isEmpty(errors)) return '';

    const codeErrors = map(keys(errors), k => k);
    let index = 0;

    while (size(questions) > index) {
      const code = get(questions, `[${index}].code`);
      if (includes(codeErrors, code)) {
        return code;
      }
      index++;
    }
    return '';
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getCodeFirstError: ${e.stack}`);
  }
  return '';
};

export { getCodeFirstError };
